import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-raw-data-include-urls',
  templateUrl: './raw-data-include-urls.component.html',
  styleUrls: ['./raw-data-include-urls.component.css'],
})
export class RawDataIncludeUrlsComponent {
  constructor(
    public dialogRef: MatDialogRef<RawDataIncludeUrlsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}
}
